//@ts-nocheck

import React, { Fragment } from 'react'

import { Col, SpacerBase, Flex } from '../../../atoms/GridSystem'
import Button from '../../../atoms/Button/Button.component'
import Icon from '../../../atoms/Icon/Icon.component'
import { Paragraph, Heading } from '../../../atoms/Typography/Typography.component'
import ItemsGrouped from '../../ItemsGrouped/ItemsGrouped.component'
import format from 'date-fns/format'
import { useTranslations } from 'next-intl';

import * as S from '../Accordion.styles'

const Event = ({
	id,
	refs,
	colorScheme,
	accordion,
	tabIndex,
	disabled,
	title,
  subtitle,
  description,
  dateFrom,
  dateTo,
  ctaPrimary,
  ctaSecondary,
	handleClick,
}) => {

  const t = useTranslations();

	return (
		<S.BaseAccordionEvent
			id={id}
			tabIndex={tabIndex}
			ref={refs.wrapper}
			disabled={disabled}
			role="region"
		>
			{/* Header */}
			<S.BaseHeaderEvent
				ref={refs.header}
				colorScheme={colorScheme}
				onClick={() => handleClick(accordion)}
				onKeyDown={(ev) =>
					(ev.key === 'Enter' || ev.key === ' ') && handleClick(accordion)
				}
				ariaLabel={accordion.open ? t('calendar.accordionCollapse') : t('calendar.accordionExpand')}
				aria-expanded={accordion.open}
				tabIndex={0}
			>
				<S.BaseHeaderEventContent>
          <S.BaseHeaderPreWrapper>
            <S.EventTypeCircle />
            <Paragraph typo="paragraphMD" content={t('calendar.accordionEventTitle')} uppercase/>
          </S.BaseHeaderPreWrapper>
          <SpacerBase xs={1} />
					{title ? <Heading typo="headingMD" content={title} weight='medium'/> : null}
				</S.BaseHeaderEventContent>
				<S.EventToggle $open={accordion.open}>
					<Icon name='chevron-down'/>
				</S.EventToggle>
			</S.BaseHeaderEvent>
			{/* Content */}
			<S.BaseContentEvent
				ref={refs.content}
				$open={accordion.open}
				aria-hidden={!accordion.open}
				className="accordion__content"
			>
				<Col xs={12} $direction="column" align="flex-start">
          {subtitle ? (
						<Paragraph typo="paragraphLG">
							{subtitle}
						</Paragraph>
					): null}
					{description ? (
						<Paragraph typo="paragraphLG">
							{description}
						</Paragraph>
					): null}

          { ctaPrimary || ctaSecondary ? (
            <>
              <SpacerBase xs={4} />
              <ItemsGrouped 
                direction={{ xs: "column", xl: "row" }} 
                space={{ xs: 16, xl: 24 }} 
                fullWidth={['xs', 'sm', 'md']}
                justify={{ xs: "center", xl: "flex-start" }}
              >
                {ctaPrimary ? <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" fullWidth inheritedColorScheme={'green'}/> : null}
                {ctaSecondary ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" fullWidth inheritedColorScheme={'green'}/> : null}
              </ItemsGrouped>
            </>
          ) : null}
				</Col>
			</S.BaseContentEvent>
		</S.BaseAccordionEvent>
	)
}

export default Event
